var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"multiple":_vm.multiple,"filterable":true,"options":_vm.options,"placeholder":_vm.placeholder,"disabled":_vm.disabled},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})
}
var staticRenderFns = []

export { render, staticRenderFns }